import Leasing from "../Pages/Leasing";
import DeleteAccountInfo from "../account/DeleteAccountInfo";
import LandingPage from "../Pages/LandingPage";
import { landings } from "../Pages/landingPages";
import React, { lazy } from "react";
import { createRoutesFromElements, Route } from "react-router-dom";
import { Home, NotFound, Shop, About, Contact } from "../Pages/index";
import { RootLayout } from "../Layout/index";
import { GamingSection } from "./GamingSection";
import SignUp from "./SignUp";
import Service from "./Service/Service";
import Cart from "./Cart";
import ProductChildLinks from "./ProductChildLinks";
import { FAQsSection } from ".";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import WarrantySection from "./WarrantySection";
import SignIn from "./SignIn";
import { GameProductDetail } from "./GameProductDetail";
import AllProducts from "./AllProducts";
import TermsAndCondition from "./TermsAndCondition";
import Disclaimer from "./Disclaimer";

// Pages most visitors never open load on demand, keeping the first download small.
const CustomersAdmin = lazy(() => import("../admin/CustomersAdmin"));
const QuotesAdmin = lazy(() => import("../admin/QuotesAdmin"));
const RequestQuote = lazy(() => import("../quotes/RequestQuote"));
const OrdersAdmin = lazy(() => import("../admin/OrdersAdmin"));
const PaymentsAdmin = lazy(() => import("../admin/PaymentsAdmin"));
const DashboardAdmin = lazy(() => import("../admin/DashboardAdmin"));
const ReportsAdmin = lazy(() => import("../admin/ReportsAdmin"));
const AbandonedCartsAdmin = lazy(() => import("../admin/AbandonedCartsAdmin"));
const StockAdmin = lazy(() => import("../admin/StockAdmin"));
const OrdersPage = lazy(() => import("../orders/OrdersPage"));
const AccountPage = lazy(() => import("../account/AccountPage"));
const ProductsAdmin = lazy(() => import("../admin/ProductsAdmin"));
const MachineBuilder = lazy(() => import("../Pages/MachineBuilder"));
const Checkout = lazy(() => import("../Pages/Checkout"));
const SearchGlobal = lazy(() => import("./SearchGlobal"));
// import Payment from "./Payment";
// import AllProducts from "./AllProducts";

const routes = createRoutesFromElements(
  <Route path="/" element={<RootLayout />}>
    <Route index element={<Home />} />
    <Route path="/admin" element={<DashboardAdmin />} />
    <Route path="/admin/reports" element={<ReportsAdmin />} />
    <Route path="/admin/abandoned-carts" element={<AbandonedCartsAdmin />} />
    <Route path="/admin/stock" element={<StockAdmin />} />
    <Route path="/admin/customers" element={<CustomersAdmin />} />
    <Route path="/admin/customers/:id" element={<CustomersAdmin />} />
    <Route path="/admin/quotes" element={<QuotesAdmin />} />
    <Route path="/request-quote" element={<RequestQuote />} />
    <Route path="/admin/orders" element={<OrdersAdmin />} />
    <Route path="/admin/payments" element={<PaymentsAdmin />} />
    <Route path="/admin/orders/:id" element={<OrdersAdmin />} />
    <Route path="/admin/products" element={<ProductsAdmin />} />
    <Route path="/about" element={<About />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/products" element={<AllProducts />} />
    <Route path="/shop/:categoryId" element={<Shop />} />
    <Route path="/product/:productId" element={<ProductChildLinks />} />
    <Route path="/build-your-machine" element={<MachineBuilder />} />
    <Route path="/leasing" element={<Leasing />} />
    {landings.map((page) => <Route key={page.path} path={page.path} element={<LandingPage page={page} />} />)}
    <Route path="/gaming-machines" element={<GamingSection />} />
    <Route
      path="/game-product-detail/:gamingId"
      element={<GameProductDetail />}
    />
    <Route path="/register" element={<SignUp />} />
    <Route path="/login" element={<SignIn />} />
    <Route path="/orders" element={<OrdersPage />} />
    <Route path="/orders/:id" element={<OrdersPage />} />
    <Route path="/account" element={<AccountPage mode="profile" />} />
    <Route path="/forgot-password" element={<AccountPage mode="forgot" />} />
    <Route path="/reset-password" element={<AccountPage mode="reset" />} />
    <Route path="/services" element={<Service />} />
    <Route path="/cart" element={<Cart />} />
    <Route path="/FAQs" element={<FAQsSection />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/delete-account" element={<DeleteAccountInfo />} />
    <Route path="/warranties" element={<WarrantySection />} />
    <Route path="*" element={<NotFound />} />
    <Route path="/checkout" element={<Checkout />} />
    <Route path="/search/:searchTerm" element={<SearchGlobal />} />
    <Route path="/termscondition" element={<TermsAndCondition />} />
    <Route path="/disclaimer" element={<Disclaimer />} />
    {/* <Route path="/payment" element={<Payment />} /> */}
    {/* <PrivateRoute path="/checkout" element={<Checkout />} /> */}
  </Route>
);

export default routes;
